import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// Models
import { InventoryEntities } from 'client/data/models/inventory';
import { VisitorEntities } from 'client/data/models/visitor';
// Utils
import { getUsurpImages } from 'client/site-modules/shared/utils/inventory/srp-images';
import { getPhotoProvider } from 'client/site-modules/shared/utils/inventory-image-utils';
import { getVdpLink, getVehicleName } from 'site-modules/shared/utils/inventory/usurp-inventory-card';
import { getPriceStringV2 } from 'site-modules/shared/utils/price-utils'; // Constants
import { DEFAULT_PRICE } from 'site-modules/shared/components/deal/deal-constants';
// Components
import { UsurpInventoryCardPhoto } from 'site-modules/shared/components/usurp-inventory-card/usurp-inventory-card-photo';
import { UsurpCardViewMore } from 'site-modules/shared/components/inventory/usurp-card-view-more/usurp-card-view-more';
import { UsurpInventoryCardDescription } from 'site-modules/car-buying-online/components/usurp-inventory-card/usurp-inventory-card-description';
import { ClickableCard } from 'site-modules/shared/components/inventory/clickable-card/clickable-card';
import './usurp-inventory-card.scss';

const getVehicleNameAriaLabel = vehicle => {
  const { prices } = vehicle;

  const vehiclePrice = prices.advertisedPrice || 0;
  return `${vehiclePrice ? getPriceStringV2(vehiclePrice) : DEFAULT_PRICE} ${getVehicleName(vehicle, true, true).join(
    ' '
  )}`;
};

export const UsurpInventoryCard = ({
  vehicle,
  visitorLocation = {},
  paymentType = '',
  isMobile = false,
  selectedPaymentType = '',
  disableInventoryMLPhotoSort = false,
  clientSideRenderImage = false,
  lazyLoadImage = false,
  importance = null,
  zipCode = '',
  includeDeliveryFee = false,
  isViewed = false,
}) => {
  const rooftopId = vehicle.dealerInfo.rooftopId || '';
  const { photoUrls, hasPhotos, photoType } = getUsurpImages(vehicle, disableInventoryMLPhotoSort);
  const vehicleName = getVehicleName(vehicle);

  const vdpLink = getVdpLink({
    vehicle,
    isNational: true,
    paymentType,
    buyonline: true,
    deliveryFee: includeDeliveryFee,
  });

  const ariaLabel = getVehicleNameAriaLabel(vehicle);

  return (
    <ClickableCard
      className="d-flex flex-column usurp-inventory-card rounded-12 overflow-hidden pos-r h-100 w-100 bg-white"
      data-dealer-rooftop-id={rooftopId}
    >
      <Fragment>
        <UsurpInventoryCardPhoto
          photos={photoUrls}
          hasPhotos={hasPhotos}
          provider={getPhotoProvider(vehicle)}
          vehicle={vehicle}
          visitorStateCode={visitorLocation.stateCode}
          isMobile={isMobile}
          vin={vehicle.vin}
          photoType={photoType}
          vdpLink={vdpLink}
          clientSideRenderImage={clientSideRenderImage}
          lazyLoadImage={lazyLoadImage}
          importance={importance}
          heartAriaLabel={ariaLabel}
          isViewed={isViewed}
          useExpandedPhotoLayout
          openLinksInNewTab
        />
        <div className="vehicle-info d-flex flex-column p-1 pos-r">
          <UsurpInventoryCardDescription
            vehicle={vehicle}
            zipCode={zipCode}
            selectedPaymentType={selectedPaymentType}
            paymentType={paymentType}
            vdpLink={vdpLink}
            includeDeliveryFee={includeDeliveryFee}
            ariaLabel={ariaLabel}
            openLinksInNewTab
          />
          <UsurpCardViewMore vehicle={vehicle} vehicleName={vehicleName} visitorLocation={visitorLocation} />
        </div>
      </Fragment>
    </ClickableCard>
  );
};

UsurpInventoryCard.propTypes = {
  vehicle: InventoryEntities.InventoryVin.isRequired,
  visitorLocation: VisitorEntities.Location,
  paymentType: PropTypes.string,
  selectedPaymentType: PropTypes.string,
  isMobile: PropTypes.bool,
  disableInventoryMLPhotoSort: PropTypes.bool,
  clientSideRenderImage: PropTypes.bool,
  lazyLoadImage: PropTypes.bool,
  importance: PropTypes.string,
  zipCode: PropTypes.string,
  includeDeliveryFee: PropTypes.bool,
  isViewed: PropTypes.bool,
};
